import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { UserService } from 'src/app/user/user.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    resetPasswordLinkForm = new FormGroup({
        email: new FormControl()
    });
    restPasswordLinkFormSubmitted: boolean;

    siteKey: string;
    private _destroyed$ = new Subject();
    error: string;
    loginSuccess = false;
    vaildCaptcha: false;
    success: string;
    emailExists: boolean | null = null;
    message: string | null;
    message_error: string | null = null;
    recaptchaToken: string;
    subscriptionArr: Subscription[] = [];
    constructor(
        private userService: UserService,
        private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private recaptchaV3Service: ReCaptchaV3Service
    ) {
        this.siteKey = '6LdI5JYoAAAAAJ5apC89TCAqrA3J1A472QHbYQSV';

        const activatesubs = this.activatedRoute.queryParams.subscribe((params) => {
            const token = params['token']; // Extract the deep link token from the query parameter

            if (token) {
                // If a token is present, navigate to the ResetPasswordComponent with the token
                this.router.navigate(['/reset-password'], {
                    queryParams: { token: token },
                });
            }
        });
        this.subscriptionArr.push(activatesubs);
    }

    submitted = false;

    ngOnInit(): void {
        this.resetPasswordLinkForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            //recaptcha: [null, Validators.required],
        });
    }

    public executeImportantAction(): void {
        const importantsubs = this.recaptchaV3Service
            .execute('importantAction')
            .subscribe((token) => {
                this.recaptchaToken = token;
                this.resetPasswordLink(this.recaptchaToken);
            });
        this.subscriptionArr.push(importantsubs);
    }
    // Getter for easy access to form fields
    get f() {
        return this.resetPasswordLinkForm.controls;
    }

    resetPasswordLink(recaptchaToken) {
        this.submitted = true;
        this.restPasswordLinkFormSubmitted = true;

        if (this.resetPasswordLinkForm.invalid) {
            return;
        }

        const emailControl = this.resetPasswordLinkForm.get('email');
        const email = emailControl ? emailControl.value || '' : '';

        const resetsubs = this.userService
            .resetPasswordLink({
                email: email,
                recaptchatoken: recaptchaToken,
            })
            .pipe(takeUntil(this._destroyed$))
            .subscribe((r) => {
                if (r['status'] == 200) {
                    this.loginSuccess = true;
                    this.message = r['message'];
                } else {
                    this.loginSuccess = false;
                    this.message_error = r['message'];
                }
            });
        this.subscriptionArr.push(resetsubs);

        // this.userService
        //     .resetPasswordLink(this.resetPasswordLinkForm.value)
        //     .pipe(takeUntil(this._destroyed$))
        //     .subscribe((r) => {
        //         if (r['status'] == 200) {
        //             this.loginSuccess = true;
        //             this.message = r['message'];
        //         } else {
        //             this.loginSuccess = false;
        //             this.message_error = r['message'];
        //         }
        //     });
        this.submitted = false;
        this.resetPasswordLinkForm.reset();
    }
    ngOnDestroy() {
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
}
